import React from "react";
import SEO from "./SEO";
import Header from "./Header";
import Footer from "./Footer";
import ServiceSide from "./ServiceSide";
import { NavLink } from "react-router-dom";

function Services() {
  return (
    <>
      <SEO
        title="Application Development Services | Web & Software Solutions – Moironix"
        description="Moironix Offers Custom Application Development Services, Including Web Apps, SaaS Solutions, and Enterprise Software. Scalable and Secure It Solutions"
        keywords="Application Development, Custom Web Application Development, PHP Application Development Services, Java Web Application Development, Net Application Development, SaaS Application Development, Web App Maintenance Services, Application Development Services, Web Application Development, Software Application Development, Custom Application Development, Web App Developers, Enterprise Application Development"
      />
      <Header />
      <div className="prt-page-title-row style1">
        <div className="prt-page-title-row-inner">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="prt-page-title-row-heading">
                  <div className="banner-vertical-block" />
                  <div className="page-title-heading">
                    <h2 className="title">Application Development</h2>
                  </div>
                  <div className="breadcrumb-wrapper">
                    <span>
                      <NavLink title="Homepage" to="/">
                        Home
                      </NavLink>
                    </span>
                    <span className="action">Application Development</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <>
        <div className="site-main">
          <div className="prt-row sidebar prt-sidebar-left clearfix">
            <div className="container">
              <div className="row">
                <div className="widget-area sidebar-left prtcol-bgcolor-yes prt-bg prt-left-span bg-base-grey">
                  <ServiceSide />
                </div>
                <div className="col-lg-8 content-area">
                  <div className="prt-service-single-content-area">
                    <div className="prt_fatured_image-wrapper mb-40 res-575-mb-20">
                      <img
                        width={859}
                        height={440}
                        className="img-fluid"
                        src="images/d3.jpeg"
                        alt="services-1"
                      />
                    </div>
                    <div className="prt-service-description">
                      <h3>Application Development</h3>
                      <p>
                        we specialize in delivering innovative and robust
                        application development services that empower businesses
                        to achieve their goals with cutting-edge technology. Our
                        team of skilled developers, designers, and project
                        managers work together to create custom applications
                        that meet your specific needs and drive your digital
                        transformation.
                      </p>
                      <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                          <ul className="service-detail-list">
                            <li className="service-detail-list-item">
                              <div className="service-detail-list-text">
                                Custom Software Development
                              </div>
                            </li>
                            <li className="service-detail-list-item">
                              <div className="service-detail-list-text">
                                Web Application Development
                              </div>
                            </li>
                          </ul>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                          <div>
                            <ul className="service-detail-list">
                              <li className="service-detail-list-item">
                                <div className="service-detail-list-text">
                                  Mobile Application Development
                                </div>
                              </li>
                              <li className="service-detail-list-item">
                                <div className="service-detail-list-text">
                                  Enterprise Application Solutions
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                          <div>
                            <ul className="service-detail-list">
                              <li className="service-detail-list-item">
                                <div className="service-detail-list-text">
                                  Support and Maintenance
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
      <Footer />
    </>
  );
}

export default Services;
